import React from 'react';
import { SvgProps } from '../icon.types';

function SmallHumidityIcon({ fillColor = '#2D3049' }: SvgProps) {
  return (
    <svg height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg">
      <defs />
      <path
        d="M12 2c6.036 6.782 9.251 10.286 7.545 15.485 0 0-1.509 5.515-7.545 5.515s-7.545-5.515-7.545-5.515C2.749 12.286 5.964 8.782 12 2zm0 3.014c-5.03516981 5.7111698-6.74833749 8.1908238-5.70806644 11.6465201L6.355 16.861l.016.048.013.048C6.501 17.357 7.688 21 12 21c4.214 0 5.4434313-3.4792908 5.610074-4.0257165L17.62 16.941l.009-.031.016-.049c1.168-3.562-.512-6.025-5.645-11.847zm2.293 6.279l1.414 1.414-6 6-1.414-1.414 6-6zM14 16c.553 0 1 .447 1 1 0 .553-.447 1-1 1-.553 0-1-.447-1-1 0-.553.447-1 1-1zm-4-4c.553 0 1 .447 1 1 0 .553-.447 1-1 1-.553 0-1-.447-1-1 0-.553.447-1 1-1z"
        fill={fillColor}
        fillRule="evenodd"
      />
    </svg>
  );
}

export { SmallHumidityIcon };
